<template>
<div class="container-fluid">
	<toolbar>
		<h2>
			<i class="fa fa-calendar"></i>
			Schedule
		</h2>

		<button v-if="hasModulePermWrite('Users')" class="btn btn-light btn-sm" v-on:click="vacationRequestModal.visible = true">
			Pending Vacation Requests...
		</button>
	</toolbar>
	<schedule-component></schedule-component>

	<modal-dialog v-if="vacationRequestModal.visible"
		:modal-visible="vacationRequestModal.visible"
		v-on:closeModal="vacationRequestModal.visible = false"
		:submit-visible="false"
		cancel-button-text="Done"
		title="Pending Vacation Requests">

		<ul v-if="vacationRequestModal.events.length > 0" class="list-group">
			<li v-for="event in vacationRequestModal.events" class="list-group-item d-flex justify-content-between">
				<div>
					<strong>{{ event.User.first_name }} {{ event.User.last_name }}</strong>
					<div>
						{{ formatDateTimeToLocal(event.start_time)}} - {{ formatDateTimeToLocal(event.end_time)}}

						<div><strong>Notes:</strong></div>
						<pre>{{event.notes}}</pre>
					</div>
				</div>

				<div style="min-width: 110px;text-align: right;">
					<div>
						<button class="btn btn-success btn-sm mb-1" v-on:click="approveReject(event.id,1)">
							<i class="fa fa-check"></i>
							Approve
						</button>
					</div>
					<div>
						<button class="btn btn-dark btn-sm" v-on:click="approveReject(event.id,0)">
							<i class="fa fa-ban"></i>
							Reject
						</button>
					</div>
				</div>
			</li>
		</ul>
		<div v-else class="alert alert-success text-center">No current pending vacation requests</div>

	</modal-dialog>
</div>
</template>
<script type="text/javascript">

import Toolbar from "@/layout_fragments/Toolbar"
import ScheduleComponent from "@/components/schedule/ScheduleComponent.vue"
import ModalDialog from "@/components/ModalDialog"

import ScheduleMixins from "@/mixins/ScheduleMixins.js"

// optionally import default styles
//import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
	name: "Schedule",
	components: {
		Toolbar,
		ScheduleComponent,
		ModalDialog
	},
	mixins: [ScheduleMixins],
	data() {
		return {
			vacationRequestModal: {
				visible: false,
				events: []
			}
		}
	},
	watch: {
		'vacationRequestModal.visible'() {
			this.fetchPendingVacationRequestEvents()
		}
	},
	methods: {
		approveReject(event_id,approve) {
			let vm = this
			this.approveRejectVacation(event_id,approve).then(response => {
				if (response.success) 
					//remove from list
					vm.vacationRequestModal.events.splice(vm.vacationRequestModal.events.findIndex(event => event.id == event_id),1)
			})
		},
		fetchPendingVacationRequestEvents() {
			let vm = this

			let params = {
				filters: [
					["is_vacation",1],
					["approved_by",0],
					["rejected_by",0],
					["start_time >",this.moment().subtract(18,"months").format("YYYY-MM-DD")]
				],
				orders: [
					["start_time","ASC"]
				],
				include: [
					{
						model: "User",
						fields: ["id","slug","first_name","last_name"]
					}
				]
			}

			this.getJSON("ScheduleEvent/get",params).then(response => {
				if (response.success)
					vm.vacationRequestModal.events = response.data
			})
		}
	},
	created() {
		this.fetchPendingVacationRequestEvents()
	}
}

</script>

<style scoped>
	pre {
		font-family: inherit;
		word-wrap: break-word;
		white-space: pre-wrap;
	}

</style>